import React, { useState, useEffect } from "react";
import borderBack from "../../../assets/images/borderBack.png";
// import ach from "../../../assets/images/ach.png";
import cardicon from "../../../assets/images/cardicon.png";
import AuthLayout from "./AuthLayout";
// import { useNavigate } from "react-router-dom";
import { Container } from "@mui/material";
import FormMainLayouts from "../../layouts/FormMainLayouts";
import PaymentAccount from "./PaymentAccount";
import CardInformation from "./CardInformation";

import {
  Header,
  Linked,
  Maincontant,
  PaymentMethodBtn,
} from "./styles/PaymentMethodStyle";
// import { useSelector } from "react-redux";

const PaymentMethod = () => {
  // const navigate = useNavigate();
  // const { user: userInfo = {} } = useSelector((state) => state?.auth);

  const [showPayAccount, SetshowPayAccount] = useState(false);
  const [showPayCard, SetshowPayCard] = useState(false);

  // const AutomatedHandler = () => {
  //   SetshowPayAccount(true);
  // };
  const CardHandler = () => {
    SetshowPayCard(true);
  };

  // useEffect(() => {
  //   if (userInfo?.payment_method) {
  //     navigate("/profile");
  //   }
  // }, []);

  const ClickHandler = (event) => {
    event.preventDefault();
  };

  return (
    <Container maxWidth="lg">
      {!showPayAccount && !showPayCard && (
        <AuthLayout arrow={true}>
          <Header>
            <Linked to="/profile" onClick={ClickHandler}>
              <img src={borderBack} alt="Linkarrow" />
            </Linked>
            <Maincontant>
              <h6>Select Payment Method</h6>
              <p>Select your desired payment method</p>
            </Maincontant>
          </Header>
          <FormMainLayouts>
            {/* <PaymentMethodBtn onClick={AutomatedHandler}>
              <img src={ach} alt="ach" />
              <div className="PaymentMethodBtnText">
                Automated Clearing House
                <span>ACH</span>
              </div>
            </PaymentMethodBtn> */}
            <PaymentMethodBtn onClick={CardHandler}>
              <img src={cardicon} alt="ach" />
              <div className="PaymentMethodBtnText">
                Card
                <span>Credit, or Debit Card</span>
              </div>
            </PaymentMethodBtn>
          </FormMainLayouts>
        </AuthLayout>
      )}

      {showPayAccount && <PaymentAccount ClickHandler={SetshowPayAccount} />}
      {showPayCard && <CardInformation ClickHandler={SetshowPayCard} />}
    </Container>
  );
};

export default PaymentMethod;
